import { useState } from "react";

// Renders the partner's logo image when the file exists, and falls back to the
// partner's name as styled text when it doesn't (logos are uploaded by the owner
// to frontend/public/partners/<slug>.png — we never hotlink trademarked logos).
export const PartnerMark = ({ name, logo, imgClassName = "", textClassName = "" }) => {
  const [ok, setOk] = useState(Boolean(logo));
  if (logo && ok) {
    return (
      <img
        src={logo}
        alt={`${name} logo`}
        className={imgClassName}
        onError={() => setOk(false)}
        loading="lazy"
      />
    );
  }
  return <span className={textClassName}>{name}</span>;
};
